"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.IllustratedMessage = void 0;
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Illustration = require("../Illustration/_Illustration");
var _IllustratedMessage = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./IllustratedMessage.css") : void 0);
var _excluded = ["additionalContent", "additionalContentProps", "children", "className", "description", "descriptionProps", "captionProps", "headline", "headlineProps", "size", "sceneContainerClassName"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-illustrated-message';

/** An **IllustratedMessage** is a recommended combination of a solution-oriented message,
 * engaging illustration, and conversational tone to better communicate an empty state
 * than just a message alone.
 *
 * An **IllustratedMessage** turns a situation (even a negative situation) into a better experience
 * for your users, while ensuring consistency. Through their human-centered approach,
 * **IllustratedMessage**s help to create a deeper connection with users by making
 * them feel understood, valued, and respected.
 *
 * To request additional illustrations, contact \#ask-core-ui. */

var IllustratedMessage = exports.IllustratedMessage = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var _context, _context2;
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(IllustratedMessage, _props)) : _props;
  var additionalContent = props.additionalContent,
    additionalContentProps = props.additionalContentProps,
    children = props.children,
    className = props.className,
    description = props.description,
    descriptionProps = props.descriptionProps,
    captionProps = props.captionProps,
    headline = props.headline,
    headlineProps = props.headlineProps,
    _props$size = props.size,
    size = _props$size === void 0 ? 'md' : _props$size,
    sceneContainerClassName = props.sceneContainerClassName,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(_IllustratedMessage.default);
  var isDot = size === 'xs';
  var isSpot = size === 'sm';
  var isDialog = size === 'md';
  var isScene = !size || size === 'lg';
  var passChildProps = function passChildProps(child, childProps) {
    if (child.displayName === 'Illustration') {
      return {
        ariaHidden: true,
        title: undefined,
        className: classnames("".concat(CSS_BLOCK, "__svg"), childProps.className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__svg--dot"), isDot), "".concat(CSS_BLOCK, "__svg--spot"), isSpot), "".concat(CSS_BLOCK, "__svg--dialog"), isDialog), "".concat(CSS_BLOCK, "__svg--scene"), isScene))
      };
    }
    if ((0, _includes.default)(_Illustration.ILLUSTRATION_TYPES).call(_Illustration.ILLUSTRATION_TYPES, child.displayName)) {
      return {
        size: size
      };
    }
    return {};
  };
  var textContent = /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, captionProps, {
    className: classnames("".concat(CSS_BLOCK, "__caption"), captionProps === null || captionProps === void 0 ? void 0 : captionProps.className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__caption--dot"), isDot), "".concat(CSS_BLOCK, "__caption--spot"), isSpot), "".concat(CSS_BLOCK, "__caption--dialog"), isDialog), "".concat(CSS_BLOCK, "__caption--scene"), isScene))
  }), /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, headlineProps, {
    className: classnames("".concat(CSS_BLOCK, "__headline"), headlineProps === null || headlineProps === void 0 ? void 0 : headlineProps.className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__headline--dot"), isDot), "".concat(CSS_BLOCK, "__headline--spot"), isSpot), "".concat(CSS_BLOCK, "__headline--dialog"), isDialog), "".concat(CSS_BLOCK, "__headline--scene"), isScene))
  }), headline), description && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, descriptionProps, {
    className: classnames("".concat(CSS_BLOCK, "__description"), descriptionProps === null || descriptionProps === void 0 ? void 0 : descriptionProps.className)
  }), description));
  var additionalContentNode = additionalContent && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, additionalContentProps, {
    className: classnames("".concat(CSS_BLOCK, "__additional"), additionalContentProps === null || additionalContentProps === void 0 ? void 0 : additionalContentProps.className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__additional--dot"), isDot), "".concat(CSS_BLOCK, "__additional--spot"), isSpot), "".concat(CSS_BLOCK, "__additional--dialog"), isDialog), "".concat(CSS_BLOCK, "__additional--scene"), isScene))
  }), additionalContent);
  var nonDotIllustratedMessage = /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, {
    ref: ref,
    className: classnames(CSS_BLOCK, className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, (0, _concat.default)(_context = "".concat(CSS_BLOCK, "--")).call(_context, size), size !== 'md'), "".concat(CSS_BLOCK, "--spot"), isSpot), "".concat(CSS_BLOCK, "--dialog"), isDialog), "".concat(CSS_BLOCK, "--scene"), isScene))
  }), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps
  }, children), textContent, additionalContentNode);
  var wrappedIllustratedMessage = isScene && size === 'lg' ? /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(CSS_BLOCK, "__large-scene-ctr"), sceneContainerClassName)
  }, nonDotIllustratedMessage) : nonDotIllustratedMessage;
  return isDot ? /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, {
    className: classnames("".concat(CSS_BLOCK, "__dot-ctr"), className),
    ref: ref
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(CSS_BLOCK, "__horizontal"), CSS_BLOCK, (0, _defineProperty2.default)({}, (0, _concat.default)(_context2 = "".concat(CSS_BLOCK, "--")).call(_context2, size), size !== 'md'))
  }, /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps
  }, children), textContent), additionalContent && /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(CSS_BLOCK, "__dot-additional-row"))
  }, children && /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(CSS_BLOCK, "__dot-additional-blank"))
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(CSS_BLOCK, "__dot-additional-ctr"))
  }, additionalContentNode))) : wrappedIllustratedMessage;
});
IllustratedMessage.displayName = 'IllustratedMessage';
IllustratedMessage.propTypes = {
  /** The headline explains the reason for the empty state, preferably in a single line.
   * Use the headline to convey the essence of your message in simple, engaging language.
   *
   * Write the headline in sentence case without an ending period (.) or other punctuation.
   * Exceptions include situations where you may want to emphasize the headline
   * with an exclamation mark (!) or question mark (?). */
  headline: _propTypes.default.node.isRequired,
  /** If there is a clear next step, include a call to action, ideally in the form of a button. */
  additionalContent: _propTypes.default.node,
  /** Additional props to spread to the additionalContent `<div>` element. */
  additionalContentProps: _propTypes.default.object,
  /** Additional props to spread to the caption `<div>` element. */
  captionProps: _propTypes.default.object,
  /** Additional classes to add to the wrapping `<div>` element. */
  className: _propTypes.default.string,
  /** Additional classes to add to the wrapping `<div>` scene container
   * at large sizes. */
  sceneContainerClassName: _propTypes.default.string,
  /** **Illustration** component to render. This is the compositional method
   * of adding an illustration.
   */
  children: _propTypes.default.node,
  /** The description adds details and tells the user what to do next, in three sentences or less.
   * Write the description in sentence case with proper punctuation.
   * You can also set links in the description. */
  description: _propTypes.default.node,
  /** Additional props to spread to the description `<div>` element. */
  descriptionProps: _propTypes.default.object,
  /** Additional props to spread to the headline `<span>` element. */
  headlineProps: _propTypes.default.object,
  /**
   * * `"xs"` – (Dot) This is the smallest size for spaces with
   * little vertical space such as table rows and smaller cards.
   * * `"sm"` – (Spot) This is the normal size for small containers, such as cards.
   * * `"md"` – (Dialog default) This is the size for medium-sized containers, such as dialogs.
   * * `"lg"` – (Scene) This is the size for large controls, such as tables and empty
   * states for an entire screen.
   */
  size: _propTypes.default.oneOf(_Illustration.ILLUSTRATION_SIZES)
};
var _default = exports.default = IllustratedMessage;